export default function LoadingScreen() {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: '#FDFAF5',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, flexDirection: 'column', gap: 24
    }}>
      <div style={{ fontSize: 32, fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 300, letterSpacing: 4, fontStyle: 'italic', color: '#2C2416' }}>
        Abstractivo
      </div>
      <div style={{ width: 40, height: 1, background: '#8B6F4E', animation: 'expand 1.2s ease-in-out infinite' }} />
      <style>{`
        @keyframes expand { 0%,100%{width:20px;opacity:.4} 50%{width:60px;opacity:1} }
      `}</style>
    </div>
  );
}
